// Generated by GitHub Copilot
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../core/services/auth.service';

/**
 * Protects private dashboard routes.
 * If the user is already cached locally, no HTTP call is made.
 * Only calls /auth/me when the session state is unknown (app reload).
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> | boolean {
    // Skip the HTTP call if we already know the user is authenticated
    if (this.auth.currentUser() !== null) {
      return true;
    }

    return this.auth.me().pipe(
      map(() => true),
      catchError(() => {
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}
